import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { addContact } from 'actions/ringCentral';
import { extractObjectFromDataTable, getSelectedPhone } from 'hooks/datatable';
import { RingCentralOriginActions } from 'UI/constants/defaults';

export const usePhoneActions = ({ columns: tableColumns }) => {
  const dispatch = useDispatch();
  const trackCommunicationAction = useCallback(
    ({ rowData, origin = RingCentralOriginActions.Default }) => {
      const item = extractObjectFromDataTable(tableColumns, ['contact'], rowData);
      const phone = getSelectedPhone({ rowData, origin });
      const { entityType, id, entityTypeCode } = item?.contact || {};

      if (!entityType || !id || !entityTypeCode || !phone) return;

      entityType &&
        dispatch(
          addContact({
            id,
            role: entityTypeCode,
            phone,
            createdAt: new Date()
          })
        );
    },
    [tableColumns, dispatch]
  );

  const getContactInfo = useCallback(({ columns, data }) => {
    const { rowData } = data;
    const item = extractObjectFromDataTable(columns, ['id', 'contact'], rowData);
    return {
      name: item?.contact?.fullName,
      entityId: item?.contact?.id,
      entityType: item?.contact?.entityType
    };
  }, []);

  return { trackCommunicationAction, getContactInfo };
};
